import { defineStore, storeToRefs } from 'pinia';
import { useBrandStore } from './brand';
import { useContentStore } from './content';
import { useMenuStore } from './menu';
import { useStoresStore } from './stores';
import type { Brand } from '@/config/brand.config';

export const useServerStore = defineStore('server', () => {
  const isServerInitiated = ref<boolean>(false);

  const serverInit = async (brand: string): Promise<void> => {
    if (!process.server || isServerInitiated.value) return;
    const configStore = useBrandStore();
    const { fetchConfig } = configStore;
    const { brandConfig } = storeToRefs(configStore);
    const { fetchLogo, fetchInformationBanner } = useContentStore();
    const { setProductsMenu, setHeaderFooterContent, setServicesMenu, setHeaderContent } = useMenuStore();
    const { setCentralStorageId } = useStoresStore();
    await fetchConfig(brand as Brand);
    const promises = [fetchLogo(), fetchInformationBanner(), setProductsMenu(), setHeaderFooterContent()];
    if (brandConfig.value.additions.servicesMenu) {
      promises.push(setServicesMenu());
      promises.push(setHeaderContent());
    }
    if (brandConfig.value.centralStorageId) setCentralStorageId(brandConfig.value.centralStorageId);
    await Promise.all(promises);
    isServerInitiated.value = true;
  };

  return {
    isServerInitiated,
    serverInit,
  };
});
